'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class;

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _transportErrorUtils = require('../utils/transportErrorUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var PartyStore = (0, _classAutobindDecorator2.default)(_class = function () {
  function PartyStore(transport) {
    _classCallCheck(this, PartyStore);

    this.transport = transport;
  }

  _createClass(PartyStore, [{
    key: 'fetchPerformanceAnalytics',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(partyId) {
        var requestOptions;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                requestOptions = { urlParams: { partyId: partyId } };
                _context.next = 4;
                return this.transport.get('/party-performance-analytics/:partyId/', requestOptions);

              case 4:
                return _context.abrupt('return', _context.sent);

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);

                if (!(0, _transportErrorUtils.isTransportErrorNotFound)(_context.t0)) {
                  _context.next = 11;
                  break;
                }

                return _context.abrupt('return', null);

              case 11:
                throw _context.t0;

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 7]]);
      }));

      function fetchPerformanceAnalytics(_x) {
        return _ref.apply(this, arguments);
      }

      return fetchPerformanceAnalytics;
    }()
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return PartyStore;
}()) || _class;

var _default = PartyStore;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(PartyStore, 'PartyStore', '/app/src/stores/PartyStore.js');
  reactHotLoader.register(_default, 'default', '/app/src/stores/PartyStore.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9zdG9yZXMvUGFydHlTdG9yZS5qcyJdLCJuYW1lcyI6WyJQYXJ0eVN0b3JlIiwiYXV0b0JpbmRNZXRob2RzIiwidHJhbnNwb3J0IiwicGFydHlJZCIsInJlcXVlc3RPcHRpb25zIiwidXJsUGFyYW1zIiwiZ2V0Il0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7O0FBQUE7Ozs7QUFFQTs7Ozs7Ozs7Ozs7Ozs7Ozs7SUFHTUEsVSxPQURMQyxnQztBQUdDLHNCQUFhQyxTQUFiLEVBQXdCO0FBQUE7O0FBQ3RCLFNBQUtBLFNBQUwsR0FBaUJBLFNBQWpCO0FBQ0Q7Ozs7OzBGQUVnQ0MsTzs7Ozs7OztBQUV2QkMsOEIsR0FBaUIsRUFBRUMsV0FBVyxFQUFDRixnQkFBRCxFQUFiLEU7O3VCQUNULEtBQUtELFNBQUwsQ0FBZUksR0FBZixDQUFtQix3Q0FBbkIsRUFBNkRGLGNBQTdELEM7Ozs7Ozs7OztxQkFHViwrRDs7Ozs7aURBQ0ssSTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztlQVFBSixVOzs7Ozs7Ozs7OzswQkFyQlRBLFUiLCJmaWxlIjoiUGFydHlTdG9yZS5qcyIsInNvdXJjZVJvb3QiOiIvYXBwIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IGF1dG9CaW5kTWV0aG9kcyBmcm9tICdjbGFzcy1hdXRvYmluZC1kZWNvcmF0b3InO1xuXG5pbXBvcnQgeyBpc1RyYW5zcG9ydEVycm9yTm90Rm91bmQgfSBmcm9tICcuLi91dGlscy90cmFuc3BvcnRFcnJvclV0aWxzJztcblxuQGF1dG9CaW5kTWV0aG9kc1xuY2xhc3MgUGFydHlTdG9yZSB7XG5cbiAgY29uc3RydWN0b3IgKHRyYW5zcG9ydCkge1xuICAgIHRoaXMudHJhbnNwb3J0ID0gdHJhbnNwb3J0O1xuICB9XG5cbiAgYXN5bmMgZmV0Y2hQZXJmb3JtYW5jZUFuYWx5dGljcyAocGFydHlJZCkge1xuICAgIHRyeSB7XG4gICAgICBjb25zdCByZXF1ZXN0T3B0aW9ucyA9IHsgdXJsUGFyYW1zOiB7cGFydHlJZH0gfTtcbiAgICAgIHJldHVybiAoYXdhaXQgdGhpcy50cmFuc3BvcnQuZ2V0KCcvcGFydHktcGVyZm9ybWFuY2UtYW5hbHl0aWNzLzpwYXJ0eUlkLycsIHJlcXVlc3RPcHRpb25zKSk7XG4gICAgfVxuICAgIGNhdGNoIChlcnJvcikge1xuICAgICAgaWYgKGlzVHJhbnNwb3J0RXJyb3JOb3RGb3VuZChlcnJvcikpIHtcbiAgICAgICAgcmV0dXJuIG51bGw7XG4gICAgICB9XG5cbiAgICAgIHRocm93IGVycm9yO1xuICAgIH1cbiAgfVxufVxuXG5leHBvcnQgZGVmYXVsdCBQYXJ0eVN0b3JlO1xuIl19